import { MapPin, Loader2 } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { useBranches } from "@/hooks/use-api";
import { useBranchStore } from "@/lib/store";
import { cn } from "@/lib/utils";
import { motion } from "framer-motion";

export function BranchSelector() {
  const selectedBranchId = useBranchStore(s => s.selectedBranchId);
  const setSelectedBranch = useBranchStore(s => s.setSelectedBranch);
  const { data: branches, isLoading } = useBranches();

  return (
    <div className="surface-panel flex flex-col gap-2 rounded-xl p-3">
      <div className="flex items-center justify-between px-1">
        <span className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-muted-foreground">
          <MapPin className="h-3 w-3" />
          Branch Filter
        </span>
      </div>
      <Select
        value={selectedBranchId}
        onValueChange={(val) => setSelectedBranch(val)}
      >
        <SelectTrigger className={cn(
          "h-9 rounded-lg border-border bg-secondary text-xs font-medium focus:ring-ring",
          selectedBranchId !== 'all' && "ring-1 ring-primary/40"
        )}>
          <SelectValue placeholder={isLoading ? "Loading..." : "Select Branch"} />
          {isLoading && <Loader2 className="h-3 w-3 animate-spin ml-2" />}
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all" className="text-xs font-medium">Consolidated View</SelectItem>
          {branches?.map((branch) => (
            <SelectItem key={branch.id} value={branch.id} className="text-xs">
              {branch.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {selectedBranchId !== 'all' && (
        <motion.div
          initial={{ opacity: 0, y: 5 }}
          animate={{ opacity: 1, y: 0 }}
          className="px-1"
        >
          <span className="text-[9px] font-bold text-primary animate-pulse">
            Regional filter active
          </span>
        </motion.div>
      )}
    </div>
  );
}
